import './index.css'

function LeftAlignedText({text,heading}){
    return <div className='left-aligned-text'>
    <h2 className='big-text'>{heading}</h2>
    <p className='small-text'>{text}</p>
    <div className='ordered-list'>
    <div className='list-item small-text'>
    <div className='list-label'>1</div>
    <div className='list-value'>Sign up.</div>
    </div>
    <div className='list-item small-text'>
    <div className='list-label'>2</div>
    <div className='list-value'>Input sites to crawl.</div>
    </div>
    <div className='list-item small-text'>
    <div className='list-label'>3</div>
    <div className='list-value'>Get tailored insights and generate post ideas.</div>
    </div>
    <div className='list-item small-text'>
    <div className='list-label'>4</div>
    <div className='list-value'>All for $5.99 a month.</div>
    </div>
    </div>
    </div>
}

export default LeftAlignedText